/**
 * イベント申込の受付待機（キャンセル待ち）エントリのステータス。
 * サーバー側 EventWaitlistEntry の enum 値をそのまま受け取るため、値を変更する場合は
 * davosbase/app/models/event_waitlist_entry.rb と合わせて変更する。
 */
export default {
  /**
   * 受付待機中（参加は未確定）
   */
  WAITING: 'waiting',

  /**
   * 空きが出て参加が確定済み
   */
  CONFIRMED: 'confirmed',
} as const
